import configInit from './init'

window.AppConfig = {
  subDomain: configInit.subDomain,
  webUrl: configInit.subDomain,
  baseApiUrl: configInit.subDomain,
  apiUrl: configInit.subDomain + 'api/v1/',
  // webSocketUrl: 'ws://localhost:8000/ws',
  webSocketUrl: 'https://dev-admin.jdmstore.id',
  clientId: '1',
  clientSecret: 'hJhsHlw7dmCvHJfW0fZ7WDedj3TxFlGQGBoyXztF',
  fbase: {
    initializeConfig: {
      apiKey: 'AIzaSyBivift-O4EzLkUvgjzH68TOD1Cz9mJs8c',
      authDomain: 'pos-jaket-distro-medan.firebaseapp.com',
      projectId: 'pos-jaket-distro-medan',
      storageBucket: 'pos-jaket-distro-medan.appspot.com',
      messagingSenderId: '583993143865',
      appId: '1:583993143865:web:075a5956730ee22863d3e8',
      measurementId: 'G-LQ3JR18661'
    },
    vapidKey: 'BDdqbys-ikOwcYVPMKUOVzXTuGeGBXns4Ck5cU0H-_1DLR8iBDpvIxh9H17b5qqn9UpH3gjVzuJjkTmF68AsmsQ'
  },
  IntervalRefreshData: 120000,
  IntervalRefreshDataDashboard: 300000,
  dateFormat: 'DD-MM-YYYY hh:mm:ss A',
  shortDateFormat: 'DD-MM-YYYY'
}



// WEBPACK FOOTER //
// ./src/config/development.js